export const MIN_INFERENCES_SAMPLE = 10;

/** Number of inferred frames to sample for the Improve flow (higher for better training data) */
export const IMPROVE_INFERENCES_SAMPLE = 30;

/** Min images in rapid-review batch to show "New Data Ready" highlight/notification */
export const IMPROVE_DATA_READY_THRESHOLD = 10;
